import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { apiFetch } from '~/lib/api';

const LOGO_URL = 'https://tbit.app/new_logo.svg';

export default function TbitInvoicesLayout() {
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Skip setup check for connect page and auth callback
  const isConnectPage = location.pathname.endsWith('/connect');
  const isAuthCallback = location.pathname.includes('/auth/callback');

  useEffect(() => {
    if (isConnectPage || isAuthCallback) {
      setChecking(false);
      return;
    }

    // Auth is handled by AuthGuard (OIDC). Here we only check setup completeness.
    apiFetch('/tbit-invoices/api/session')
      .then(res => res.json())
      .then(data => {
        setUserEmail(data.email || null);
        if (!data.setup_complete) {
          // Determine which wizard step to start at
          const startStep = !data.has_gmail ? 0 : !data.has_netsuite ? 1 : 2;
          navigate(`/tbit-invoices/connect?step=${startStep}`, { replace: true });
        }
      })
      .catch(() => {
        // If session call fails, redirect to connect wizard
        navigate('/tbit-invoices/connect', { replace: true });
      })
      .finally(() => setChecking(false));
  }, [navigate, isConnectPage, isAuthCallback]);

  if (checking) {
    return (
      <div className="min-h-screen bg-base-200 flex items-center justify-center">
        <span className="loading loading-spinner loading-lg text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-200">
      <header className="navbar bg-base-100 shadow-sm px-6">
        <div className="flex-1 flex items-center gap-2">
          <Link to="/tbit-invoices/dashboard" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="TBit" className="h-6 w-auto" />
            <span className="text-base font-normal text-base-content/60">Invoices</span>
          </Link>
        </div>
        <nav className="flex-none flex items-center gap-4">
          <ul className="menu menu-horizontal gap-1 px-1 text-sm">
            <li><Link to="/tbit-invoices/dashboard">Panel</Link></li>
            <li><Link to="/tbit-invoices/upload">Subir</Link></li>
            <li><Link to="/tbit-invoices/memorias">Reglas</Link></li>
            <li><Link to="/tbit-invoices/team">Equipo</Link></li>
          </ul>
          {userEmail && (
            <span className="text-xs text-base-content/50">{userEmail}</span>
          )}
        </nav>
      </header>
      <main className="container mx-auto px-4 py-8 max-w-6xl">
        <Outlet />
      </main>
    </div>
  );
}
